import {getSiteUrl} from "@/helpers/functions";

export interface EventLocation {
    name: string;
    address?: string;
    url?: string;
}

export interface SeoSchemaEventProps {
    name: string;
    startDate: string;
    endDate?: string;
    location: string | EventLocation;
    url?: string;
    description?: string;
    image?: string;
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${siteUrl}${path}`;
};

const buildLocation = (siteUrl: string, location: string | EventLocation) => {
    if (typeof location === "string") {
        if (/^https?:\/\//i.test(location)) {
            return {
                "@type": "VirtualLocation",
                "url": location,
            };
        }
        return {
            "@type": "Place",
            "name": location,
            "address": location,
        };
    }
    const place: Record<string, unknown> = {
        "@type": "Place",
        "name": location.name,
    };
    if (location.address) place.address = location.address;
    if (location.url) place.url = toAbsoluteUrl(siteUrl, location.url);
    return place;
};

export function SeoSchemaEvent({
                                   name,
                                   startDate,
                                   endDate,
                                   location,
                                   url,
                                   description,
                                   image,
                               }: SeoSchemaEventProps) {
    const siteUrl = getSiteUrl();

    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": name,
        "startDate": startDate,
        "location": buildLocation(siteUrl, location),
    };

    if (endDate) schema.endDate = endDate;
    if (url) schema.url = toAbsoluteUrl(siteUrl, url);
    if (description) schema.description = description;
    if (image) schema.image = toAbsoluteUrl(siteUrl, image);

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
